import {ValgtAvgiver} from '../avgiver';
import {bestemMiljo} from "../utils";

const kunderegAdapterBaseUrl = utledKunderegAdapterBaseUrl();

export interface Kunde {
    fnr: string;
    navn: {
        fornavn: string;
        etternavn: string;
    }
}

export function hentNyEier(fnr: string, etternavn: string) {
    return fetch(`${kunderegAdapterBaseUrl}/person/`, {
        credentials: 'include',
        body: JSON.stringify({
            oppslagsfnr : fnr,
            navn: etternavn
        })
    });
}

export function hentOrg(organisasjonsnummer: string) {
    return fetch(`${kunderegAdapterBaseUrl}/organisasjon/${organisasjonsnummer}`, {
        credentials: 'include',
    });
}

/**
    Hvis kallet er vellykket returneres Kunde-object i Response body.
**/
export function hentMeg(): Promise<Response> {
    return fetch(`${kunderegAdapterBaseUrl}/innlogget-bruker`, {
        credentials: 'include',
        referrerPolicy: 'no-referrer-when-downgrade',
    });
}

export function hentInnlogget(avgiver : ValgtAvgiver) {
    if (avgiver && avgiver.type === 'enhet') {
        let headers = new Headers();
        headers.append('AVGIVERID', avgiver.id);
        return fetch(`${kunderegAdapterBaseUrl}/innlogget-avgiver`, {
            credentials: 'include',
            headers: headers,
        });
    } else {
        return hentMeg();
    }
}

function utledKunderegAdapterBaseUrl(): string {
    switch (bestemMiljo()) {
        case 'stm':
            return 'https://kundereg-adapter.utv.atlas.vegvesen.no';
        case 'atm':
            return 'https://kundereg-adapter.test.atlas.vegvesen.no';
        case 'prod':
            return 'https://kundereg-adapter.atlas.vegvesen.no';
    }
}
